import React from 'react';

import WebsiteAdminFetchingSettingNumericFieldRow, {
	WebsiteAdminFetchingSettingNumericFieldRowUnit,
} from '~/components/app/WebsiteAdminFetchingSettingNumericFieldRow';



type Props = {
	mainRequestTimeoutMs: number,
	name: string,
};

const WebsiteAdminFetchingSettingNavigationTimeoutFieldRow: React.FC<Props> = (props) => {
	const {
		mainRequestTimeoutMs,
		name,
	} = props;

	return (
		<WebsiteAdminFetchingSettingNumericFieldRow
			autoValue={mainRequestTimeoutMs}
			label="Navigation Timeout"
			name={name}
			unit={WebsiteAdminFetchingSettingNumericFieldRowUnit.Millisecond}
		/>
	);
};



export default WebsiteAdminFetchingSettingNavigationTimeoutFieldRow;
